<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
        @selection-change="selectionChange"
      >
        <template slot="menuLeft" v-if="model != 'view'">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord">
            新 增</el-button
          >
        </template>
        <template slot-scope="scope" slot="menu" v-if="model != 'view'">
          <el-button type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>
          <el-button type="text" size="small" @click="deleteRecord(scope.row)">删除 </el-button>
        </template>
      </avue-crud>
    </div>
    <hr-dialog
      :title="formTitle"
      :allowFull="false"
      width="60%"
      :visible.sync="healthTestFormVisible"
    >
      <template slot="body">
        <healthTestForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="healthTestFormVisible"
          @success="recordSuccess"
          :personData="row"
        ></healthTestForm>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import healthTestForm from './healthTestForm.vue';
import { getHealthExamPage, removeHealthExam } from '@/api/nursingHome/healthData.js';
export default {
  components: { healthTestForm },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      healthTestFormVisible: false,
      formRow: {},
      data: [],
      formTitle: '新增',
      formModel: 'add',
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: this.model != 'view',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '姓名',
            prop: 'elderlyName',
          },
          {
            label: '手机号',
            prop: 'phone',
          },
          {
            label: '体检日期',
            prop: 'examDate',
          },

          {
            label: '体检项目',
            prop: 'examItem',
          },
          {
            label: '体检结果',
            prop: 'examResult',
            type: 'select',
            dataType: 'number',
            dicData: [
              {
                dictKey: 0,
                dictValue: '正常',
              },
              {
                dictKey: 1,
                dictValue: '异常',
              },
            ],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '体检单位',
            prop: 'examUnit',
          },
          {
            label: '备注',
            prop: 'remark',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchForm: {},
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    addRecord(row) {
      this.formTitle = '新增';
      this.formModel = 'add';
      this.formRow = row;
      this.healthTestFormVisible = true;
    },

    editRecord(row) {
      this.formTitle = '编辑';
      this.formModel = 'edit';
      this.formRow = row;
      this.healthTestFormVisible = true;
    },
    deleteRecord(row) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        removeHealthExam(row.id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.onLoad();
        });
      });
    },
    initData() {
      this.searchForm.nursinghomeId = this.row.nursinghomeId;
      this.searchForm.elderlyId = this.row.id;
    },
    recordCancle() {
      this.healthTestFormVisible = false;
    },
    recordSuccess() {
      this.healthTestFormVisible = false;
      this.onLoad();
    },
    onLoad() {
      getHealthExamPage(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize },
          this.searchForm
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
